import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-014c7610"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Prompt", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "hint"
}
const _hoisted_4 = { class: "list-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You have not added any elements to your prompt yet.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click on a prompt element to start.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Alternatively, you can paste your existing "),
  /*#__PURE__*/_createElementVNode("code", null, "PROMPT"),
  /*#__PURE__*/_createTextVNode(" string to import it:")
], -1))
const _hoisted_9 = {
  for: "import-ps1",
  class: "import-ps1"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "PROMPT", -1))
const _hoisted_11 = {
  key: 0,
  class: "import-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_PromptElement = _resolveComponent("PromptElement")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_IconButton, {
      style: _normalizeStyle({ visibility: _ctx.empty ? 'hidden' : undefined }),
      title: "Remove all elements",
      icon: "TrashIcon",
      onClick: _ctx.clear
    }, null, 8, ["style", "onClick"]),
    _hoisted_2,
    (!_ctx.empty)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Drag elements to reorder them or click the × icon to remove them."))
      : _createCommentVNode("", true),
    _createElementVNode("ol", _hoisted_4, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.elements,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.elements) = $event)),
        "item-key": "id",
        onEnd: _ctx.storeState
      }, {
        item: _withCtx(({ element }) => [
          _createElementVNode("li", null, [
            _createVNode(_component_PromptElement, {
              id: element.id
            }, null, 8, ["id"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onEnd"])
    ]),
    _createVNode(_component_EmptyState, { empty: _ctx.empty }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("label", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(":  "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "import-ps1",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ps1input) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ps1inputError = '')),
            placeholder: "echo %PROMPT%",
            spellcheck: "false"
          }, null, 544), [
            [_vModelText, _ctx.ps1input]
          ])
        ]),
        _createVNode(_component_IconButton, {
          icon: "ArrowDownOnSquareIcon",
          title: "Import PS1",
          onClick: _ctx.importPS1
        }, null, 8, ["onClick"]),
        (_ctx.ps1inputError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.ps1inputError), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["empty"])
  ], 64))
}